import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";

const CATEGORIES = [
  "Black Entrepreneurs", "Black Fathers", "Black Mothers", "Black Families",
  "Black Couples", "Black Professionals", "Black Creatives", "Black History",
  "Black Culture", "Community", "Legacy", "Style", "Art", "Success Stories",
];

export default function BlackExcellence() {
  return (
    <div className="relative">
      <SEO
        title="Black Excellence Unveiled | Culture, Legacy & Black Excellence"
        description="Black Excellence Unveiled is the cultural editorial platform from Crowned Canvas Creations — celebrating Black entrepreneurs, families, creatives, culture and legacy."
        path="/black-excellence-unveiled"
      />
      <Header />
      <main className="pt-24 md:pt-32">
        <section className="relative">
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_60%_50%_at_15%_30%,rgba(130,73,55,0.3),transparent_60%)]" aria-hidden />
          <div className="relative max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16 py-14 md:py-20">
            <p className="overline">The Cultural Platform</p>
            <h1 className="font-serif-display text-4xl md:text-5xl lg:text-[80px] leading-[1] mt-5 max-w-5xl">
              Black Excellence<br /><span className="italic text-[#D4AF37]">Unveiled.</span>
            </h1>
            <p className="text-white/70 mt-6 max-w-2xl font-light leading-relaxed text-base md:text-lg">
              A premium editorial platform from Crowned Canvas Creations celebrating Black entrepreneurs, families, creatives, culture and legacy. Real stories. No fabrications. Coming soon.
            </p>
          </div>
        </section>

        <section className="py-16 md:py-24 border-t border-white/5 bg-[#111111]">
          <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16">
            <div className="mb-10">
              <p className="overline">The Categories</p>
              <h2 className="font-serif-display text-3xl md:text-4xl lg:text-5xl mt-4 leading-[1.05]">
                What we&apos;ll cover.
              </h2>
            </div>
            <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-px bg-white/5">
              {CATEGORIES.map((c) => (
                <div key={c} data-testid={`beu-cat-${c.toLowerCase().replace(/\s/g, "-")}`}
                  className="bg-[#080808] p-6 md:p-8 hover:bg-[#824937]/15 transition-colors">
                  <p className="font-serif-display text-lg md:text-xl leading-tight">{c}</p>
                  <p className="overline text-white/40 mt-3">Coming Soon</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-24 md:py-32 border-t border-white/5">
          <div className="max-w-[1100px] mx-auto px-6 md:px-12 text-center">
            <Sparkles className="w-6 h-6 text-[#D4AF37] mx-auto" strokeWidth={1.5} />
            <p className="overline mt-5">Contextual Invitation</p>
            <h2 className="font-serif-display text-4xl md:text-6xl mt-5 leading-[1.02]">
              Your story is part of the culture.<br /><span className="italic text-[#D4AF37]">Turn it into art.</span>
            </h2>
            <div className="mt-9 flex flex-wrap justify-center gap-3">
              <Link to="/#experiences" data-testid="beu-cta"
                className="inline-flex items-center gap-3 bg-[#D4AF37] text-black px-7 py-4 text-xs uppercase tracking-[0.22em] font-semibold hover:bg-[#e6c245] transition-all">
                Explore The Crowned Experiences<ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
